import {Request} from "./Request";
import {Mode} from "app/models/Model";

export class Delete extends Request implements Mode {
    method = 'DELETE';

    constructor(action: string) {
        super();
    }
}